import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Loader } from "@/components/common";
import { fmtDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Bell, CheckCircle } from "@phosphor-icons/react";

export default function Notifications() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  if (!items) return <Loader />;

  return (
    <div>
      <PageHeader title="Notifications" subtitle="System alerts & reminders" icon={Bell} />
      {items.length === 0 ? (
        <EmptyState icon={Bell} title="All caught up" message="You have no notifications right now." />
      ) : (
        <div className="space-y-2 max-w-3xl">
          {items.map((n) => (
            <Card key={n.id} className={`p-4 flex items-start gap-3 ${n.read ? "opacity-60" : ""}`} data-testid={`notif-${n.id}`}>
              <div className={`h-9 w-9 rounded-md flex items-center justify-center shrink-0 ${n.read ? "bg-secondary text-muted-foreground" : "bg-primary/10 text-primary"}`}>
                <Bell size={18} weight="duotone" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium text-sm">{n.title}</div>
                <div className="text-sm text-muted-foreground">{n.message}</div>
                <div className="text-xs text-muted-foreground mt-1">{fmtDate(n.created_at)}</div>
              </div>
              {!n.read && (
                <button onClick={() => markRead(n.id)} className="text-primary hover:text-primary/70" title="Mark read" data-testid={`read-${n.id}`}>
                  <CheckCircle size={20} />
                </button>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
